import styled from 'styled-components';

export const GovernmentIdFileFieldWrapper = styled.div`
  cursor: pointer !important;

  input[readOnly] {
    cursor: pointer !important;
    background-color: #fff !important;
  }

  input[type='file'] {
    display: none !important;
  }
`;
